// Module
var code = "<div id=\"content\">\n    <p><form id=\"add\">\n        키워드: <input type=\"text\" id=\"keyword\">\n        <button type=\"submit\">추가</button>\n    </form></p>\n    <p>\n        클릭해서 제거:\n        &nbsp;\n        <span id=\"buttons\"></span>\n    </p>\n    <div id=\"chart-wrapper\"></div>\n</div>";
// Exports
module.exports = code;